/* línkè · 世界书（Lorebook）
   关键词触发的背景资料注入。多条目并行启用，命中按 priority 注入。 */
import { parseMessageContent } from './image.js';

const K_LIST = 'lingke.lb.entries';

export const DEFAULT_SEARCH_DEPTH = 4;
export const DEFAULT_PRIORITY = 100;

function uid() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return 'l-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
}

function readJSON(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}
function writeJSON(key, value) {
  try { localStorage.setItem(key, JSON.stringify(value)); } catch {}
}

export function loadEntries() {
  return readJSON(K_LIST, []);
}
export function saveEntries(list) {
  writeJSON(K_LIST, list);
}

export function createEntry(partial = {}) {
  return {
    id: uid(),
    keys: partial.keys || [],
    content: partial.content || '',
    priority: typeof partial.priority === 'number' ? partial.priority : DEFAULT_PRIORITY,
    enabled: partial.enabled !== false,
    case_sensitive: !!partial.case_sensitive,
    match_whole_word: !!partial.match_whole_word,
    search_depth:
      typeof partial.search_depth === 'number'
        ? partial.search_depth
        : DEFAULT_SEARCH_DEPTH,
  };
}

export function upsertEntry(e) {
  const list = loadEntries();
  const idx = list.findIndex((x) => x.id === e.id);
  if (idx === -1) list.push(e);
  else list[idx] = e;
  saveEntries(list);
  return e;
}

export function deleteEntry(id) {
  saveEntries(loadEntries().filter((e) => e.id !== id));
}

export function toggleEntry(id) {
  const list = loadEntries();
  const idx = list.findIndex((e) => e.id === id);
  if (idx === -1) return;
  list[idx] = { ...list[idx], enabled: !list[idx].enabled };
  saveEntries(list);
}

function escapeRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/* 在最近 N 条消息里找关键词命中。
   每条 entry 用自己的 search_depth 单独切片。
   返回按 priority 倒序的命中条目。 */
export function matchLorebook(entries, messages) {
  if (!entries?.length || !messages?.length) return [];
  const hits = [];
  for (const e of entries) {
    if (!e.enabled || !e.keys?.length) continue;
    const depth = e.search_depth || DEFAULT_SEARCH_DEPTH;
    // 只拿消息的纯文字部分做匹配：带图消息的原文是 JSON+base64 大字符串，
    // 直接搜会又慢又可能被乱码误触发关键词
    const recent = messages
      .slice(-depth)
      .map((m) => parseMessageContent(m.content).text)
      .join('\n');
    const haystack = e.case_sensitive ? recent : recent.toLowerCase();
    const matched = e.keys.some((k) => {
      if (!k) return false;
      const needle = e.case_sensitive ? k : k.toLowerCase();
      if (e.match_whole_word) {
        return new RegExp(`\\b${escapeRegex(needle)}\\b`).test(haystack);
      }
      return haystack.includes(needle);
    });
    if (matched) hits.push(e);
  }
  hits.sort((a, b) => (b.priority || 0) - (a.priority || 0));
  return hits;
}
